import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroCultureIndexAreaMaps,
  setMaps,
} from 'redux/reducers/meteorologyAgroCultureIndexAreaReducer';
import { store } from 'redux/store';
import { CultureIndexAreaMap, emptyMapParams } from 'types/Meteorology/Agro/CultureIndex/Area/map';

const MAPS_MAX = 2;

export default function useMapsControl() {
  const maps: CultureIndexAreaMap[] = useSelector(selectMeteorologyAgroCultureIndexAreaMaps);
  const addMapDisabled = maps.length >= MAPS_MAX;
  const removeMapDisabled = maps.length <= 1;

  const addMap = useCallback(() => {
    if (maps.length >= MAPS_MAX) return;
    const id = maps.length ? maps[maps.length - 1].id + 1 : 1;
    store.dispatch(setMaps([
      ...maps,
      {
        id,
        data: undefined,
        error: undefined,
        params: { ...emptyMapParams },
        filename: '',
        isLoading: false,
      },
    ]));
  }, [maps]);

  const removeMap = useCallback((map: CultureIndexAreaMap) => {
    if (maps.length <= 1) return;
    store.dispatch(setMaps(maps.filter((m: CultureIndexAreaMap) => m !== map)));
  }, [maps]);

  return {
    maps,
    addMapDisabled,
    removeMapDisabled,
    addMap,
    removeMap,
  };
}
